import React from "react";
import "../assets/css/heroassessment.css";
import heroImg from "../assets/img/rectangle.png"; // adjust path as needed

const HeroAssessment = () => {
  return (
    <section className="position-relative">
      <img src={heroImg} className="img-fluid w-100 hero-img" alt="Wind farm" />
      <div className="position-absolute hero-text">
        <h1>
          <span className="highlight">Cyber Security</span>
          <br />
          <div style={{marginTop:"4px"}}></div>
          <span className="highlight">Management Maturity</span>
        </h1>
      </div>
    </section>
  );
};

export default HeroAssessment;
